webpackJsonp([38,47],{

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      mountDone: false,
      alert: true,
      currentStatus: 'Signing in...'
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    site_settings: function site_settings() {
      return this.$store.getters.getSettings;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  beforeCreate: function beforeCreate() {
    var urlParams = new URLSearchParams(window.location.search);
    var token = urlParams.get('token');
    if (!token) return window.location.replace('/');
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.mountDone = true;

      _this.verify(_this.$route.query.token); // this.signInUser(this.$route.query.token)

    }, 2000);
  },
  methods: {
    verify: function verify(token) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://us-central1-defense-exchange.cloudfunctions.net/api/verifyToken?type=exchange', {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(function (res) {
        var customToken = res.data.token;
        return _this2.signInUser(customToken);
      }).catch(function () {
        _this2.currentStatus = 'Signin failed. Redirecting...';
        setTimeout(function () {
          _this2.$router.replace('/sso-failed');
        }, 3000);
      });
    },
    updateCompanyDataSource: function updateCompanyDataSource(cid) {
      var uri = 'https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2';
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(uri, {
        id: cid,
        datasource: 'community-exchange'
      });
    },
    signInUser: function signInUser(token) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$firebase.auth().signOut();

              case 2:
                _this3.$store.dispatch('clearApp');

                _this3.$firebase.auth().signInWithCustomToken(token).then(function (data) {
                  var user = data && data.user ? data.user : data;
                  _this3.currentStatus = 'Signing in...';
                  return _this3.$firebase.database().ref("/users/".concat(user.uid)).once('value', /*#__PURE__*/function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(userSnap) {
                      var userDetails, logId, companylegalname;
                      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              userDetails = userSnap.val();

                              if (!userDetails) {
                                _context.next = 13;
                                break;
                              }

                              _context.next = 4;
                              return _this3.updateCompanyDataSource(userDetails.cid);

                            case 4:
                              _context.next = 6;
                              return _this3.$store.dispatch('autoSignIn', userDetails);

                            case 6:
                              logId = user.uid.slice(0, 10) + new Date(Number(user.metadata.b)).getTime();
                              localStorage.setItem('logId', logId);

                              _this3.$firebase.database().ref("level_priviledge/".concat(userDetails.role)).on('value', function (snapshot) {
                                var levelPrivileges = snapshot.val();

                                _this3.$store.commit('setUserPrivilege', levelPrivileges);
                              });

                              if (userSnap.val().cid) {
                                companylegalname = userSnap.val().cid;

                                _this3.$firebase.database().ref('companies/' + companylegalname).once('value').then(function (snapshot) {
                                  var company = snapshot.val();

                                  if (!company.otherinfo) {
                                    var toolbarAlert = {
                                      active: true,
                                      type: 'warning',
                                      message: "Please complete the <a href=\"/questionnaire\"><b>company questionnaire<b></a> to take full advantage of the site"
                                    };

                                    _this3.$store.commit('setToolbarAlert', toolbarAlert);
                                  }

                                  _this3.$store.dispatch('setCompany', snapshot.val());
                                });
                              }

                              return _context.abrupt("return", _this3.$router.replace('/user/feed'));

                            case 13:
                              throw new Error('user not found.');

                            case 14:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }).catch(function () {
                  _this3.currentStatus = 'Signing in failed. Redirecting...';
                  setTimeout(function () {
                    _this3.$router.replace('/');
                  }, 3000);
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sso-view{height:100vh;width:100%;padding-bottom:30px;padding-top:200px;position:relative;overflow:hidden}.sso-view .sso-card{width:500px;margin:10px auto;text-align:center}.sso-view .sso-card img{max-width:100%;max-height:70px;display:block;margin:20px auto}.sso-view .sso-card h1,.sso-view .sso-card h2,.sso-view .sso-card h3,.sso-view .sso-card h4,.sso-view .sso-card h5{color:#fff}.sso-view .sso-card i{padding-top:30px;font-size:60px;color:#fff}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/SsoSigninView.vue"],"names":[],"mappings":"AACA,UACE,aAAc,AACd,WAAY,AACZ,oBAAqB,AACrB,kBAAmB,AACnB,kBAAmB,AACnB,eAAiB,CAClB,AACD,oBACI,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACtB,AACD,wBACM,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,gBAAkB,CACvB,AACD,mHACM,UAAe,CACpB,AACD,sBACM,iBAAkB,AAClB,eAAgB,AAChB,UAAe,CACpB","file":"SsoSigninView.vue","sourcesContent":["\n.sso-view {\n  height: 100vh;\n  width: 100%;\n  padding-bottom: 30px;\n  padding-top: 200px;\n  position: relative;\n  overflow: hidden;\n}\n.sso-view .sso-card {\n    width: 500px;\n    margin: 10px auto;\n    text-align: center;\n}\n.sso-view .sso-card img {\n      max-width: 100%;\n      max-height: 70px;\n      display: block;\n      margin: 20px auto;\n}\n.sso-view .sso-card h1, .sso-view .sso-card h2, .sso-view .sso-card h3, .sso-view .sso-card h4, .sso-view .sso-card h5 {\n      color: #ffffff;\n}\n.sso-view .sso-card i {\n      padding-top: 30px;\n      font-size: 60px;\n      color: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("5def661d", content, true, {});

/***/ }),

/***/ 1646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "sso-view row wrap",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    })
  }, [_c('v-fade-transition', [(_vm.mountDone) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "sso-card"
  }, [_c('img', {
    attrs: {
      "src": _vm.site_settings.styles.general.logo
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Signing in to Defense Exchange.")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.currentStatus))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1447)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1282),
  /* template */
  __webpack_require__(1646),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/38.25a2615fff4a8e122776.js